export enum TipOptions {
  RECURRENT = 'RECURRENT',
  ONE_TIME = 'ONE_TIME',
}

export enum ProductType {
  subscription = 'subscription',
  common = 'common'
}
